import Vue from 'vue'

export default {
  list: async (offset, limit, role, period) => {
    return Vue.axios.get('/teachers?offset=' + offset + '&limit=' + limit + '&role=' + role + '&period=' + period);
  }
}
